module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"projectOverdateHint":"@:common.project已过期，暂时无法更新PPT文件。升级为永久@:common.project可解除限制。","projectLockedHint":"@:common.project被锁定，暂时无法更新PPT文件。使用永久@:common.project额度可以解除限制。","upgradeProject":"升级@:common.project","unlockProject":"解锁@:common.project"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/components/index/list/item/index.vue
// module id = 347
// module chunks = 3